var riot = require('riot');
module.exports = riot.tag2('item', '<span class="index">{opts.index}.</span> <p> <a class="title" href="{href()}" target="_blank">{itemdata.title}</a> <span class="domain" show="{showDomain()}"> ({filters.domain(itemdata.url)}) </span> </p> <p class="subtext"> <span show="{showInfo()}"> {itemdata.score} points by <a href="#user/{itemdata.by}">{itemdata.by}</a> </span> {filters.fromNow(itemdata.time)} ago <span class="comments-link" show="{showInfo()}"> | <a href="#item/{itemdata.id}">{itemdata.descendants} comments</a> </span> </p>', '', '', function(opts) {
  var self = this
  self.itemdata = opts.data

  this.href = function() {
    return self.itemdata.url || ('#/item/' + self.itemdata.id)
  }.bind(this)

  this.showInfo = function() {
    return self.itemdata.type === 'story' || self.itemdata.type === 'poll'
  }.bind(this)

  this.showDomain = function() {
    return self.itemdata.type === 'story'
  }.bind(this)
}, '{ }');
